import { Pipe, PipeTransform } from '@angular/core';
import { AssetShipment } from '../models/entities/asset-shipment';


@Pipe({
  name: 'asset-shipment-pipe'
})

export class AssetShipmentPipe implements PipeTransform {
  
  constructor(){}

  transform(assetShipment: AssetShipment, field: string): any {
    let result = assetShipment[field];

     if (field == 'progressLevel') {
      if  (result == 0)   return "<div class='label-orange'>" + 'Nouvelle'   + "</div>";
      if  (result == 10)  return "<div class='label-blue'>"   + 'Expédiée'   + "</div>";
      if  (result == 100) return "<div class='label-gray'>"   + 'Cloturée'   + "</div>";
    }

    return result;
  }
}
